import { useState } from "react";
import { adminLogin, setAdminPassword } from "@/lib/api";
import { Loader2 } from "lucide-react";

export const AdminLogin = ({ onLogin }) => {
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await adminLogin(pwd);
      setAdminPassword(pwd);
      onLogin();
    } catch (err) {
      setError(err?.response?.data?.detail || "Ugyldig passord");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#F3F5E7]">
      <div className="w-full max-w-sm text-center fade-in">
        <p className="text-[10px] uppercase tracking-[0.45em] text-[#68919B] mb-4">
          Admin
        </p>
        <h1 className="font-serif text-4xl text-[#3D5E68] font-light">
          Innholdsstyring
        </h1>
        <p className="mt-4 text-sm text-[#5A7682] font-light">
          Logg inn for å redigere innholdet på bryllupssiden.
        </p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <div>
            <label
              htmlFor="admin-pwd"
              className="block text-[10px] uppercase tracking-[0.3em] text-[#68919B] mb-3 text-left"
            >
              Admin-passord
            </label>
            <input
              id="admin-pwd"
              type="password"
              autoFocus
              value={pwd}
              onChange={(e) => {
                setPwd(e.target.value);
                if (error) setError("");
              }}
              data-testid="admin-login-input"
              className={`w-full bg-transparent border-b py-3 text-center text-lg text-[#3D5E68] focus:outline-none transition-colors font-light tracking-wider ${
                error ? "border-[#9E0232]" : "border-[#68919B]/40 focus:border-[#3D5E68]"
              }`}
            />
            {error && (
              <p className="mt-3 text-xs text-[#9E0232] font-light tracking-wide">
                {error}
              </p>
            )}
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full px-12 py-4 bg-[#68919B] text-[#F3F5E7] text-xs uppercase tracking-[0.3em] hover:bg-[#3D5E68] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {busy && <Loader2 size={14} className="animate-spin" />}
            Logg inn
          </button>
        </form>
      </div>
    </div>
  );
};
